const $btn = $("[data-js-popup-button]")

const openPopup = (src) =>
  $.magnificPopup.open({
    items: {
      src,
      type: "inline",
    },
    fixedContentPos: true,
    fixedBgPos: true,
    closeMarkup: '<div class="mfp-close"/>',
  })

$btn.on("click", (e) => {
  const data = $(e.target).data("popup-target")
  const target = document.querySelector(`[data-popup=${data}]`)
  openPopup(target)
})

const $closeBtn = $("[data-js-close-popup]")

$closeBtn.on("click", () => {
  const magnificPopup = $.magnificPopup.instance
  magnificPopup.close()
})

export default openPopup



// WEBPACK FOOTER //
// ./src/blocks/popups/popups.js